module.exports = __webpack_public_path__ + "img/26.2a36e271.jpg";